import { createSelector } from 'reselect';

export const getAgents = state => state.agents.all;

export const getCurrentAgentId = state => state.agents.currentId;

export const getCurrentAgentIdString = createSelector(
  getCurrentAgentId,
  id => id || '',
);

export const getCurrentAgent = createSelector(
  getAgents,
  getCurrentAgentId,
  (agents, currentId) => agents.find(agent => agent.id === currentId),
);
